import { immerable } from "@/app/lib/system/immer-wrapper";
// my imports:
import { GameMode } from "@/app/lib/game-state/game-types";

// "Partial" makes all types optional. Neat!
type UserHistoryJSON = Partial<{
    hasVisited: {
        pyramid?: boolean;
        story?: boolean;
    };
    lifetimePyramidSolves: number;
    streakCount: number;
}>

export class UserHistory {
    [immerable] = true
    hasVisited: Record<GameMode, boolean> = {
        pyramid: false,
        story: false
    };
    lifetimePyramidSolves: number = 0;
    streakCount: number = 0;

    exportJSON() : string {
        return JSON.stringify(this);
    }

    // only imports the fields if they exist
    // only cares about the fields that are in the class
    importJSON(json: string) : UserHistory {
        const raw: UserHistoryJSON = JSON.parse(json);

        if (!raw)
            return this;

        this.lifetimePyramidSolves = raw.lifetimePyramidSolves ?? this.lifetimePyramidSolves;
        this.streakCount = raw.streakCount ?? this.streakCount;

        this.hasVisited.pyramid =
            raw.hasVisited?.pyramid ?? this.hasVisited.pyramid;

        this.hasVisited.story =
            raw.hasVisited?.story ?? this.hasVisited.story;

        return this;
    }
}